import {
    Box,
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from "@material-ui/core"
import DateFnsUtils from "@date-io/date-fns"
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import {
    PLATAFORMAS,
    SITUACOES,
    TIPOS_FORMA_PAGAMENTO,
    TIPOS_PEDIDO,
} from "./constants"

const ChipsMulti = ({ label, options, value, onChange }) => {
    const toggle = v => {
        if (value.includes(v)) onChange(value.filter(x => x !== v))
        else onChange([...value, v])
    }
    return (
        <Box>
            <Typography variant="caption" color="textSecondary" style={{ display: "block" }}>
                {label}
            </Typography>
            <Box display="flex" flexWrap="wrap" style={{ gap: 6, marginTop: 4 }}>
                {options.map(opt => {
                    const ativo = value.includes(opt.value)
                    return (
                        <Chip
                            key={String(opt.value)}
                            label={opt.label}
                            clickable
                            color={ativo ? "primary" : "default"}
                            variant={ativo ? "default" : "outlined"}
                            onClick={() => toggle(opt.value)}
                            size="small"
                        />
                    )
                })}
            </Box>
        </Box>
    )
}

export default function Filtros({
    filtros,
    setFiltros,
    formasPagamento,
    estabelecimentos,
    onLimpar,
    loading,
}) {
    const setCampo = (campo, valor) => setFiltros(prev => ({ ...prev, [campo]: valor }))

    return (
        <Paper
            variant="outlined"
            style={{
                padding: 16,
                borderRadius: 10,
                border: "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDateTimePicker
                            label="Data início"
                            inputVariant="outlined"
                            size="small"
                            ampm={false}
                            format="dd/MM/yyyy HH:mm"
                            value={filtros.dataInicio}
                            onChange={d => setCampo("dataInicio", d)}
                            fullWidth
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDateTimePicker
                            label="Data fim"
                            inputVariant="outlined"
                            size="small"
                            ampm={false}
                            format="dd/MM/yyyy HH:mm"
                            value={filtros.dataFim}
                            onChange={d => setCampo("dataFim", d)}
                            fullWidth
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label="Nome do cliente"
                        variant="outlined"
                        size="small"
                        value={filtros.nomeCliente}
                        onChange={e => setCampo("nomeCliente", e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label="Telefone"
                        variant="outlined"
                        size="small"
                        value={filtros.telefone}
                        onChange={e => setCampo("telefone", e.target.value)}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label="Código do pedido"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={filtros.codigoPedido}
                        onChange={e => setCampo("codigoPedido", e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        label="Cupom de desconto"
                        variant="outlined"
                        size="small"
                        value={filtros.cupomDesconto}
                        onChange={e => setCampo("cupomDesconto", e.target.value)}
                        fullWidth
                    />
                </Grid>

                {estabelecimentos?.length > 1 && (
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <InputLabel>Estabelecimento (sub-filtro)</InputLabel>
                            <Select
                                value={filtros.estabelecimentoFiltro || ""}
                                onChange={e =>
                                    setCampo("estabelecimentoFiltro", e.target.value || "")
                                }
                                label="Estabelecimento (sub-filtro)"
                            >
                                <MenuItem value="">
                                    <em>Todos</em>
                                </MenuItem>
                                {estabelecimentos.map(est => (
                                    <MenuItem key={est.id} value={est.id}>
                                        {est.nome || est.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}

                <Grid item xs={12} sm={6} md={3}>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel>Formas de pagamento</InputLabel>
                        <Select
                            multiple
                            value={filtros.idsFormasPagamento}
                            onChange={e => setCampo("idsFormasPagamento", e.target.value)}
                            renderValue={selected =>
                                (formasPagamento || [])
                                    .filter(fp => selected.includes(fp.id))
                                    .map(fp => fp.nome || fp.descricao)
                                    .join(", ") || ""
                            }
                            label="Formas de pagamento"
                        >
                            {(formasPagamento || []).map(fp => (
                                <MenuItem key={fp.id} value={fp.id}>
                                    <Checkbox
                                        checked={filtros.idsFormasPagamento.includes(fp.id)}
                                    />
                                    <ListItemText primary={fp.nome || fp.descricao} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <ChipsMulti
                        label="Tipo de pedido"
                        options={TIPOS_PEDIDO}
                        value={filtros.tiposPedido}
                        onChange={v => setCampo("tiposPedido", v)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChipsMulti
                        label="Plataforma"
                        options={PLATAFORMAS}
                        value={filtros.plataformas}
                        onChange={v => setCampo("plataformas", v)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChipsMulti
                        label="Situação"
                        options={SITUACOES}
                        value={filtros.situacoes}
                        onChange={v => setCampo("situacoes", v)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChipsMulti
                        label="Tipo de forma de pagamento"
                        options={TIPOS_FORMA_PAGAMENTO}
                        value={filtros.tiposFormaPagamento}
                        onChange={v => setCampo("tiposFormaPagamento", v)}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography variant="caption" color="textSecondary">
                        Emissão de Nota Fiscal
                    </Typography>
                    <RadioGroup
                        row
                        value={filtros.temNotaFiscal === null ? "" : String(filtros.temNotaFiscal)}
                        onChange={e => {
                            const v = e.target.value
                            setCampo("temNotaFiscal", v === "" ? null : v === "true")
                        }}
                    >
                        <FormControlLabel value="" control={<Radio size="small" />} label="Todos" />
                        <FormControlLabel
                            value="true"
                            control={<Radio size="small" />}
                            label="Com NFCe"
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio size="small" />}
                            label="Sem NFCe"
                        />
                    </RadioGroup>
                </Grid>
            </Grid>

            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                    onClick={onLimpar}
                    disabled={loading}
                    style={{ textTransform: "none", color: "#6b7280" }}
                >
                    Limpar filtros
                </Button>
            </Box>
        </Paper>
    )
}
